import React from "react";
import ContactForm from "./ContactForm";
import Location from "./Location";
import "./Contact.css";

const ContactHome = () => {
  return (
    <div>
      <div className="w-full max-w-full py-16 px-4">
        <div className="grid lg:grid-cols-6 lg:gap-6">
          <div className="lg:col-span-3 xl:col-span-2">
            <ContactForm />
          </div>
          <div className="lg:col-span-3 xl:col-span-4">
            <Location />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactHome;
